module.exports = __webpack_public_path__ + "images/dashboard-progress-no-color-a02bf7e63e5fa9488674abb4fcbe66ca.png";